export const getServiceConversionEligibility = (service = {}) => {
    const status = service?.current_service_financial?.status ?? service?.status;
    const isTransferred = service?.is_transferred === true || Number(service?.is_transferred) === 1;

    if (isTransferred) {
        return { canConvert: false, reason: 'Dịch vụ nguồn đã được chuyển đổi trước đó.' };
    }

    const statusMessages = {
        danglam: 'Dịch vụ đã bắt đầu thực hiện nên không thể chuyển đổi.',
        dahoanthanh: 'Dịch vụ đã hoàn thành nên không thể chuyển đổi.',
        huy: 'Dịch vụ đã bị hủy nên không thể chuyển đổi.',
    };
    if (status !== 'chualam') {
        return {
            canConvert: false,
            reason: statusMessages[status] || 'Chỉ dịch vụ chưa thực hiện mới được phép chuyển đổi.',
        };
    }

    if (Boolean(service?.financial_snapshot?.has_completed_refund)) {
        return {
            canConvert: false,
            reason: 'Dịch vụ có phiếu thu đã phát sinh hoàn tiền nên không thể thực hiện chuyển đổi.',
        };
    }

    return { canConvert: true, reason: null };
};

export const buildConversionFinancialSummary = ({
    oldServiceAmount = 0,
    newServiceAmount = 0,
    allocatedAmount = 0,
    outstandingAmount = 0,
    netObligation = 0,
    customerBalance = 0,
} = {}) => {
    const oldAmount = Number(oldServiceAmount || 0);
    const newAmount = Number(newServiceAmount || 0);
    const paidAllocatedAmount = Number(allocatedAmount || 0);
    const sourceOutstandingAmount = Number(outstandingAmount || 0);
    const sourceNetObligation = Number(netObligation || oldAmount);
    const availableCustomerBalance = Number(customerBalance || 0);
    const difference = newAmount - oldAmount;
    const sourceAppliedAmount = Math.min(paidAllocatedAmount, newAmount);
    const remainingAfterSource = Math.max(0, newAmount - sourceAppliedAmount);
    const existingBalanceAppliedAmount = Math.min(availableCustomerBalance, remainingAfterSource);
    const amountToPay = Math.max(0, remainingAfterSource - existingBalanceAppliedAmount);
    const amountToReturnToBalance = Math.max(0, paidAllocatedAmount - newAmount);

    let action = 'NONE';
    if (amountToPay > 0) action = 'COLLECT';
    if (amountToReturnToBalance > 0) action = 'RETURN_TO_BALANCE';

    return {
        oldAmount,
        newAmount,
        paidAllocatedAmount,
        sourceOutstandingAmount,
        sourceNetObligation,
        availableCustomerBalance,
        difference,
        debtReducedAmount: Math.min(sourceOutstandingAmount, Math.max(0, sourceNetObligation - newAmount)),
        sourceAppliedAmount,
        existingBalanceAppliedAmount,
        amountToPay,
        amountToReturnToBalance,
        action,
    };
};

export const buildServiceCompareData = (service = {}) => {
    const quantity = Number(service?.quantity ?? 1) || 1;
    const salePrice = Number(service?.sale_price ?? service?.service?.price ?? service?.price ?? 0);

    return {
        name: service?.service?.name || service?.service_name || service?.name || '',
        salePrice,
        quantity,
        amount: Number(service?.amount ?? (salePrice * quantity)),
    };
};
